(function ($) {
    /**
     * Get proper declension of word "miesiąc" (month) based on number
     */
    function getMonthsWord(months) {
        if (months === 1) {
            return 'miesiąc';
        }

        if (months >= 2 && months <= 4) {
            return 'miesiące';
        }

        return 'miesięcy';
    }

    /**
     * Update payment type message with current variant length
     */
    function updatePaymentTypeMessage(paymentType) {
        const $messageBox = $('.offer-30 .payment-type-message');
        if ($messageBox.length === 0) return;

        const subscriptionMessage = $messageBox.data('subscriptionMessage');
        const onetimeMessage = $messageBox.data('onetimeMessage');
        const $activeVariant = $('.offer-30 #select-variant li.active');
        const variantLength = parseInt($activeVariant.data('variant-length')) || 1;

        let message = paymentType === 'subscription' ? subscriptionMessage : onetimeMessage;

        // Replace placeholders for subscription message
        if (paymentType === 'subscription') {
            const monthsWord = getMonthsWord(variantLength);
            message = message.replace('{months}', variantLength);
            message = message.replace('{months_word}', monthsWord);
        }

        $messageBox.html(message);
    }

    /**
     * Get current active payment type
     */
    function getActivePaymentType() {
        const $activePaymentType = $('.offer-30 #select-payment-type li.active');
        return $activePaymentType.length > 0 ? $activePaymentType.data('paymentType') : 'onetime';
    }

    // Payment type select handler (Subscription/Onetime)
    $('.offer-30 .offer-30__select.payment-type li').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        $this.parent().find('li').removeClass('active');
        $this.addClass('active');
        const paymentType = $this.data('paymentType');

        updatePaymentTypeMessage(paymentType);

        // Trigger variant change to update prices with new product type
        const $activeVariant = $('.offer-30 #select-variant li.active');
        if ($activeVariant.length > 0) {
            $activeVariant.trigger('click');
        }
    });

    // Package buttons handler
    $('.offer-30 .offer-30__select.package li').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        const package_id = $(this).data('packageId');

        $('.offer-30_column').each(function () {
            if ($(this).data('package') === package_id - 1) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });
    });

    // Sticky header for package selector
    document.querySelectorAll('.offer-30 .package-select-wrapper').forEach(elem => new IntersectionObserver((entries, observer) => {
            for (const entry of entries) {
                entry.target.classList.toggle('stuck', !entry.isIntersecting)
            }
        },
        {
            rootMargin: `-${parseInt(window.getComputedStyle(elem).getPropertyValue('top')) + 1}px 0px`,
            threshold: 1,
        }).observe(elem));

    $('.offer-30 .offer-30__select.variant li').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        const variant_id = $(this).data('variant');
        const variant_title = $(this).find('.variant-title').text();
        const variant_length = $(this).data('variant-length');
        const variant_show_price_months = $(this).data('variant-show-price-months');
        const show_promo_prices = $(this).parents('.offer-30').data('showPromoPrices');

        // Update payment type message
        const paymentType = getActivePaymentType();
        updatePaymentTypeMessage(paymentType);

        $('.offer-30_column').each(function () {
            const $column = $(this);
            const hasSubscription = $column.data('hasSubscription');

            // Get the correct variants based on payment type
            let variants;
            if (paymentType === 'subscription' && hasSubscription) {
                variants = $column.data('variantsSubscription');
            } else {
                variants = $column.data('variantsOnetime');
            }
            const $price_package = $(this).find('.prices .price_package .price');
            const $price_month = $(this).find('.prices .price-month strong');
            const $price_month_del = $(this).find('.prices .price-month del');
            const $price_months = $(this).find('.price_package .price_for_x_months');

            if ( ( !show_promo_prices && parseInt(variant_length) !== 1 ) || (show_promo_prices && variants[variant_id]['is_on_sale'] ) ) {
                $price_month_del.show();
            } else {
                $price_month_del.hide();
            }

            if(variant_show_price_months) {
                $price_months.show();
            } else {
                $price_months.hide();
            }

            $(this).find('.variant_length span').text(variant_title);

            let price_per_month = formatPrice(variants[variant_id]['price'] / variant_length);
            let base_price_per_month = ( ! show_promo_prices) ? formatPrice(variants[0]['price']) : formatPrice(variants[variant_id]['display_regular_price'] / variant_length);

            $price_month.text(price_per_month);
            $price_package.html(variants[variant_id]['price_html']);
            $price_month_del.text(base_price_per_month);

            const $add_to_cart = $(this).find('.product a');
            const $gtm4wp_data = $(this).find('.gtm4wp_productdata')
            const variants_gtm4wp_data = $(this).data('gtm4wp-data');

            // Calculate savings based on payment type
            // Both onetime and subscription compare variants (1 month vs 3 months vs 6 months)
            let savings = formatPrice(variants[0]['price'] * variant_length - variants[variant_id]['price']);

            const $package_savings = $(this).find('.package_savings');
            const savings_copy = $package_savings.data('prototype').replace('%s', savings);

            $package_savings.text(savings_copy);
            if (savings !== '0') {
                $(this).find('.package_savings').removeClass('hidden');
            } else {
                $(this).find('.package_savings').addClass('hidden');
            }

            const $properties = $(this).find('.property');

            $properties.each(function () {
                if (!$(this).data('showOn').includes(variant_id.toString())) {
                    $(this).addClass('hidden');
                } else {
                    $(this).removeClass('hidden');
                }
            });

            const $omnibus = $(this).find('.omnibus');
            $omnibus.html(variants[variant_id]['omnibus_msg']);

            $add_to_cart.attr('href', `?add-to-cart=` + variants[variant_id]['variation_id']);
            $add_to_cart.attr('data-product_id', variants[variant_id]['variation_id'])
            $gtm4wp_data.attr('data-gtm4wp_product_data', variants_gtm4wp_data[variant_id]);
        });

        const $package_info = $('.package-info');
        if ($package_info.length > 0) {
            const package_description = $package_info.data('descriptions')[variant_id];
            $package_info.html(package_description);
        }
    });

    function formatPrice(price) {
        price = (Number.isInteger(price)) ? price : price.toFixed(2);
        return price.toString().replace('.', ',');
    }

    function adjustColumnTopHeights() {
        const $columnTop = $('.offer-30_column-top');
        const $columnTopPrices = $('.offer-30_column-top .prices');
        const $subheadings = $('.offer-30_column-top .subheading');
        let columnTopHeight = 0;
        let columnTopPricesHeight = 0;
        let subheadingsHeight = 0;

        $columnTop.css('min-height', '');
        $columnTopPrices.css('min-height', '');
        $subheadings.css('min-height', '');

        $subheadings.each(function () {
            if ($(this).innerHeight() > subheadingsHeight) {
                subheadingsHeight = $(this).innerHeight();
            }
        });

        $subheadings.css('min-height', subheadingsHeight);

        $columnTopPrices.each(function () {
            if ($(this).innerHeight() > columnTopPricesHeight) {
                columnTopPricesHeight = $(this).innerHeight();
            }
        });

        $columnTopPrices.css('min-height', columnTopPricesHeight);

        $columnTop.each(function () {
            if ($(this).innerHeight() > columnTopHeight) {
                columnTopHeight = $(this).innerHeight();
            }
        });
    }

    $(document).ready(adjustColumnTopHeights);
    $(window).on('resize', adjustColumnTopHeights);
    $(document).ready(function(){
        $('.offer-30__columns').scrollLeft(0);
    });

    function checkStickyHeader() {
        $('.offer-30-packages-comparison table thead').each(function() {
            const $thead = $(this);
            const $table = $thead.closest('table');
            const tableTop = $table.offset().top;
            const scrollTop = $(window).scrollTop();
            const siteHeaderHeight = 82;

            if (scrollTop + siteHeaderHeight > tableTop) {
                $thead.addClass('is-stuck');
            } else {
                $thead.removeClass('is-stuck');
            }
        });
    }

    $(window).on('scroll', checkStickyHeader);
    checkStickyHeader();


    $('body').on('click', function (e) {
        if ($(e.target).parents().hasClass('property') || $(e.target).hasClass('property')) {
            e.stopPropagation();
            return;
        }
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
    });

    $('.expand-button').on('click', function(){
        $('.offer-30-packages-comparison').removeClass('collapsed');
    });

    $(document).on("keydown", (event) => {
        if (event.key === "Escape" || event.keyCode === 27) {
            closeModal();
        }
    });

    $('#offer-30-video-modal .modal-close').on('click', closeModal);

    $('#offer-30-video-modal .modal-wrapper').on('click', () => {
        closeModal();
    });

    $('#offer-30-video-modal .modal').on('click', (e) => {
        e.stopPropagation();
    });

    function closeModal() {
        $('#offer-30-video-modal video')[0]?.pause();
        $('#offer-30-video-modal').fadeOut(300);
        $('body').css('overflow', 'auto');
    }

    const $propertyElements = $('.offer-30 .property, .offer-30-packages-comparison td.property');

    $propertyElements.on('click', function (e){
        $('.expand-button').trigger('click');
        openTooltip($(this).find('.tooltip'), e);
    });

    if(window.innerWidth > 992){
        $propertyElements.on('mouseover', function (e){
            openTooltip($(this).find('.tooltip'), e);
        });
    }

    $propertyElements.on('mouseout', function (event){
        var e = event.toElement || event.relatedTarget;
        if ($(e).hasClass('tooltip-open') || $(e).parents().hasClass('tooltip-open') ) {
            return;
        }

        $('.tooltip').removeClass('open')
        $('.tooltip-open').remove();
    });

    function openTooltip($tt, event) {
        if(event.type === 'click' && $(event.target).hasClass('play-icon') && $tt.hasClass('open')) {
            $('.tooltip-video').trigger('click');
            return;
        }

        if($tt.hasClass('open')) return;
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
        $tt.addClass('open');

        const ID = $tt.parent().data('id');
        const tooltip_content = $tt.data('tooltip-content');
        const tooltip_video = $tt.data('video');
        const $tooltip = $(`${tooltip_content}`);
        $tt.append($tooltip);
        $tooltip.attr('data-id', ID);

        $tooltip.find('.tooltip-video').on('click', function (){
            $('#offer-30-video-modal video').attr('src', tooltip_video).attr('controls', 'controls');
            $('#offer-30-video-modal video')[0].play();
            $('#offer-30-video-modal').fadeIn(300);
            $('body').css('overflow', 'hidden');
            $('.tooltip-open').remove();
            $tt.removeClass('open');
        });
    }

    // Initialize payment type message on page load
    $(document).ready(function() {
        const paymentType = getActivePaymentType();
        if ($('.offer-30 .payment-type-message').length > 0) {
            updatePaymentTypeMessage(paymentType);
        }
    });

})(jQuery);